import { createStore }  from 'vuex';

import ramp             from "./modules/ramp.module";
import auth             from "./modules/auth.module";

export default createStore({ modules: { auth, ramp } });
